<div class="filter-node" [class.filter-node-nested]="depth() > 0">
  <div class="flex items-center gap-2">
    <soft-ds-tabs class="filter-node-operator-tabs"
                  [tabs]="operatorTabs()"
                  [variant]="'segmented'"
                  [size]="'sm'"
                  [value]="node().operator"
                  (valueChange)="$event && editor.setGroupOperator(node().uuid, $event)">
    </soft-ds-tabs>
    @if (depth() > 0) {
      <soft-ds-button mode="iconOnly" variant="ghost" size="xs"
                      class="ml-auto"
                      [aria-label]="'#CORE_FILTER.CUSTOM.REMOVE' | translate"
                      (click)="editor.remove(node().uuid)"
                      data-testid="filter-node-remove-group">
        <soft-ds-icon name="fa-regular fa-trash-can" />
      </soft-ds-button>
    }
  </div>

  <div class="filter-node-children flex flex-col gap-3">
    @for (child of node().filters; track child.uuid) {
      @if (child.type === 'conditions') {
        <soft-filter-node [node]="asGroup(child)" [depth]="depth() + 1"></soft-filter-node>
      } @else {
        <div class="filter-condition flex flex-col gap-2" data-testid="filter-condition-row">
          <div class="flex items-center gap-2">
            <soft-ds-select class="flex-1 min-w-0"
                            size="md"
                            [items]="fieldItems()"
                            [value]="asCondition(child).field"
                            (valueChange)="$event && editor.setConditionField(child.uuid, $event)">
            </soft-ds-select>
            <soft-ds-button mode="iconOnly" variant="ghost" size="xs"
                            [aria-label]="'#CORE_FILTER.CUSTOM.REMOVE' | translate"
                            (click)="editor.remove(child.uuid)"
                            data-testid="filter-condition-remove">
              <soft-ds-icon name="fa-regular fa-trash-can" />
            </soft-ds-button>
          </div>
          <soft-ds-select class="w-full"
                          size="md"
                          [items]="operatorItems(asCondition(child).field)"
                          [value]="asCondition(child).operator"
                          (valueChange)="$event && editor.setConditionOperator(child.uuid, $event)">
          </soft-ds-select>
          @if (editor.getItemConfig(asCondition(child).field); as itemConfig) {
            <soft-filter-value-input [itemConfig]="itemConfig"
                                     [operator]="asCondition(child).operator"
                                     [value]="conditionValue(child)"
                                     (valueChange)="editor.setConditionValue(child.uuid, $event)"
                                     (editValues)="editor.editValues(asCondition(child))">
            </soft-filter-value-input>
          }
        </div>
      }
    }
    @empty {
      <p class="ds-caption filter-node-empty">{{ '#CORE_FILTER.CUSTOM.EMPTY' | translate }}</p>
    }
  </div>

  <div class="flex items-center gap-1">
    <soft-ds-button variant="ghost" size="xs"
                    (click)="editor.addCondition(node().uuid)"
                    data-testid="filter-node-add-condition">
      + {{ '#CORE_FILTER.CUSTOM.ADD_CONDITION' | translate }}
    </soft-ds-button>
    <soft-ds-button variant="ghost" size="xs"
                    (click)="editor.addGroup(node().uuid)"
                    data-testid="filter-node-add-group">
      + {{ '#CORE_FILTER.CUSTOM.ADD_GROUP' | translate }}
    </soft-ds-button>
  </div>
</div>
